import React from "react";
import { Form, DatePicker } from "antd";
import moment from "moment";

// Utility to detect Safari
const isSafari = () =>
  typeof navigator !== "undefined" &&
  navigator.userAgent.indexOf("Safari") !== -1 &&
  navigator.userAgent.indexOf("Chrome") === -1;

export default function UltraDateFormItem({
  name = "date",
  label = "Date",
  required = true,
  placeholder = "MM-DD-YYYY",
  format = "MM-DD-YYYY",
  disabledDate, // pass your own function
  validator, // pass your own validator function
  defaultPickerValue,
  showToday = false,
  ...restFormProps // for any other Form.Item props
}) {
  // Default: only allow dates between 100 and 18 years ago
  const defaultDisabledDate = (current) => {
    if (!current) return true;
    const today = moment().endOf("day");
    const eighteenYearsAgo = moment().subtract(18, "years").endOf("day");
    const hundredYearsAgo = moment().subtract(100, "years").startOf("day");
    return (
      current.isAfter(eighteenYearsAgo) ||
      current.isBefore(hundredYearsAgo) ||
      current.isAfter(today)
    );
  };

  // Default validator: must be 18 or older
  const defaultValidator = (_, value) => {
    if (!value) return Promise.reject("Please select your date");
    const eighteenYearsAgo = moment().subtract(18, "years").endOf("day");
    if (value.isSameOrBefore(eighteenYearsAgo)) {
      return Promise.resolve();
    }
    return Promise.reject("Must be 18 or older!");
  };

  return (
    <Form.Item
      label={label}
      name={name}
      validateFirst={true}
      rules={[
        {
          required,
          message: `Please select your ${label.toLowerCase()}`,
        },
        ...(isSafari()
          ? []
          : [
              {
                validator: validator || defaultValidator,
              },
            ]),
      ]}
      {...restFormProps}
    >
      <DatePicker
        disabledDate={disabledDate || defaultDisabledDate}
        style={{ width: "100%" }}
        format={format}
        placeholder={placeholder}
        defaultPickerValue={
          defaultPickerValue || moment().subtract(18, "years").startOf("day")
        }
        showToday={showToday}
      />
    </Form.Item>
  );
}
